// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bes_a bhs_bj"};